/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState } from 'react'

import './Home.scss'

import { Link, useNavigate } from 'react-router-dom'

import DeliveryIcon from '../../../assets/svg/PeykProfileIcon.svg'
import PeykProfileIcon from '../../../assets/svg/PeykProfile.svg'
import PeykHatBannerPic from '../../../assets/svg/HatIcon.svg'
import PeykMenuOrder from '../../../assets/svg/PeykMenuOrder.svg'
import PeykMenuAnalytic from '../../../assets/svg/PeykMenuAnalytic.svg'
import PeykMenuMessage from '../../../assets/svg/PeykMenuMessage.svg'
import PeykMenuOrderDone from '../../../assets/svg/PeykMenuOrderDone.svg'
import Arrow from '../../../assets/svg/Arrow.svg'
import { get, post } from '../../../services/https'

export default function index() {
  const token = localStorage.getItem('token')

  const [name, setName] = useState('...')
  const [orders, setOrders] = useState([])

  const navigate = useNavigate()

  useEffect(() => {
    post('/api/front/users/verify', {
      token: localStorage.getItem('token')
      }).then(response => {
        // console.log(response)
        if (response.data.message === 'احراز هویت با موفقیت انجام شد') {

        } else {
          navigate('/peyk')
        }
    }).catch(() => {
      navigate('/peyk')
    })

    post('/api/front/peyks/info', {
        'phoneNumber': localStorage.getItem('phoneNumber')
      }).then(response => {
        setName(response.data.data.name)

        get(`/api/front/order/peyk/list/${response.data.data._id}`)
          .then(response => {
            console.log(response)
            setOrders(response.data.data)
          })
      })
      
  }, [navigate, token])

  return (
    <div id='peyk'>
      <header className='header'>
        <section className='header__name'>
          <div>
            <img src={DeliveryIcon} alt="DeliveryIcon" />
          </div>
          <div className='profileName'>
            <span className='profileName__self'>
              {name}
            </span>
            <span className='profileName__tag'>
              سفیر کانولی
            </span>
          </div>
        </section>
        <section className='header__profile'>
          <Link to='/peyk/profile'>
            <img src={PeykProfileIcon} alt="PeykProfileIcon" />
          </Link>
        </section>
      </header>
      <main className='body'>
        <section className='banner'>
          <div className="banner__up">
            <div className="text">
              نــــــــــــــرم افـــــــــــــــــــزار<br />
              مـــــدیریت ســــــــفارشات<br />
              رســــــــــتوران کـــــــــــانولی
            </div>
            <div className="pic">
              <img src={PeykHatBannerPic} alt="PeykHatBannerPic" />
            </div>
          </div>
          <div className="banner__down">
            <div className="text">
              Cannoli Delivery Application
            </div>
          </div>
        </section>

        <section className="icons">
          <div className="icons__up">
            <Link to='/peyk/orders' className="menu">
              <div className="menu__icon">
                <img src={PeykMenuOrder} alt="PeykMenuOrder" />
              </div>
              <div className="menu__text">
                سفارشات جاری
              </div>
            </Link>
            <Link to='/peyk/analytic' className="menu">
              <div className="menu__icon">
                <img src={PeykMenuAnalytic} alt="PeykMenuAnalytic" />
              </div>
              <div className="menu__text">
                آمار و حسابداری
              </div>
            </Link>
          </div>
          <div className="icons__down">
            <Link to='/peyk/messages' className="menu">
              <div className="menu__icon">
                <img src={PeykMenuMessage} alt="PeykMenuMessage" />
              </div>
              <div className="menu__text">
                پیام‌ها
              </div>
            </Link>
            <Link to='/peyk/orders' className="menu">
              <div className="menu__icon">
                <img src={PeykMenuOrderDone} alt="PeykMenuOrderDone" />
              </div>
              <div className="menu__text">
                انجام شده
              </div>
            </Link>
          </div>
        </section>

        <section className="orders">
          <div className="body__title">
            سفارشات جاری
          </div>
          {orders?.map((item, index) => (
            <ul className='ordersList' key={index}>
              <li className='ordersList__item'>
                <Link to={`/peyk/current/${item._id}`}>
                  <span>
                    {item.user[0].name}
                  </span>
                  <span>
                    مشاهده <img src={Arrow} alt="Arrow" />
                  </span>
                </Link>
              </li>
            </ul>
          ))}
        </section>
      </main>
      <footer>
        <section className='copyright--signUp'>
          قدرت گرفته از <Link to='https://ibills.ir'>Ibills</Link> ، توسعه توسط <Link to='https://ham-team.ir'>هم‌تیم</Link>
        </section>
      </footer>
    </div>
  )
}
